import React from "react";
import { useTranslation } from "react-i18next";

const ChangeLogConsent = () => {

    const { t } = useTranslation();

    return (
        <p>
            {t('consent.changeLog.content')}
        </p>
    );
}

export default ChangeLogConsent;